import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-extract-views',
  templateUrl: './extract-views.component.html',
  styleUrls: ['./extract-views.component.css']
})
export class ExtractViewsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
